import { faChevronLeft, faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router';
import styled, { css } from 'styled-components/macro';
import { WxLabel } from '../..';
import { COLORS } from '../../../styles/colors';
import { breakpoint, max_width } from '../../../styles/constants';

export type CustomNavStyle = 'chevron' | 'cross';

interface CustomNavProps {
  label: string;
  navStyle: CustomNavStyle;
  noBackButton?: boolean;
  black?: boolean;
  forceDesktopLabelCenter?: boolean;
  forceDestination?: string;
}
export const CustomNav = ({
  label,
  navStyle,
  noBackButton = false,
  black = false,
  forceDesktopLabelCenter = false,
  forceDestination,
}: CustomNavProps) => {
  const navigate = useNavigate();

  return (
    <FullWidth $black={black}>
      <Wrapper
        $navStyle={navStyle}
        $forceDesktopLabelCenter={forceDesktopLabelCenter}
      >
        <div>
          <WxLabel
            label={label}
            active
            black={black}
            style={{ cursor: 'pointer' }}
          />
          {!noBackButton && (
            <BackIcon
              icon={navStyle === 'cross' ? faTimes : faChevronLeft}
              onClick={() => {
                if (forceDestination) navigate(forceDestination);
                else navigate(-1);
              }}
              $navStyle={navStyle}
              $dark={black}
              $forceDesktopLabelCenter={forceDesktopLabelCenter}
            />
          )}
        </div>
      </Wrapper>
    </FullWidth>
  );
};

const FullWidth = styled.div<{ $black: boolean }>`
  width: var(--viewportWidth);
  margin-inline: 50%;
  transform: translateX(-50%);
  border-bottom: ${({ $black }) =>
    $black ? '1px solid rgba(255, 255, 255, 0.1)' : 'none'};
  margin-bottom: 1.25rem;
`;

const Wrapper = styled.nav<{
  $navStyle: CustomNavStyle;
  $forceDesktopLabelCenter: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-block: 1.35rem;

  > div {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
  }

  @media (min-width: ${breakpoint}) {
    width: ${max_width};
    margin-inline: auto;

    > div {
      gap: 0.825rem;
      ${({ $navStyle }) =>
        $navStyle === 'cross'
          ? css`
              flex-direction: row;
              justify-content: space-between;
            `
          : css`
              flex-direction: row-reverse;
              justify-content: flex-end;
            `};
    }

    > div {
      ${({ $forceDesktopLabelCenter }) =>
        $forceDesktopLabelCenter &&
        css`
          justify-content: center;
        `}
    }
  }
`;

const BackIcon = styled(FontAwesomeIcon)<{
  $navStyle?: CustomNavStyle;
  $dark?: boolean;
  $forceDesktopLabelCenter: boolean;
}>`
  font-weight: 900;
  font-size: 0.875rem;
  cursor: pointer;
  color: ${({ theme, $dark }) =>
    $dark ? theme.colors.black : theme.colors.white};
  position: absolute;

  ${({ $navStyle }) =>
    $navStyle === 'cross'
      ? css`
          right: 1.25rem;
          justify-self: flex-start;
        `
      : css`
          left: 1.25rem;
        `};

  @media (min-width: ${breakpoint}) {
    position: ${({ $forceDesktopLabelCenter }) =>
      $forceDesktopLabelCenter ? 'absolute' : 'relative'};

    ${({ $navStyle }) =>
      $navStyle === 'cross'
        ? css`
            right: calc((100% - ${max_width}) / 2);
            justify-self: flex-start;
          `
        : css`
            left: calc((100% - ${max_width}) / 2);
          `};

    right: ${({ $forceDesktopLabelCenter }) =>
      $forceDesktopLabelCenter ? 'absolute' : 'relative'};
  }

  &:hover {
    color: ${COLORS.red};
  }
`;
